import {IdName, IObjectType, ISyncField} from "../../index";
import {Item} from "./list/item";
import {Group} from "./list/group";
import {ILanguage} from "../../constants/Language";

interface ITableColumnDefinition {
    cellCss?: string
    key: keyof ISyncField
    content: (obj: Group | Item) => string | number
    title?: string
    tt: string
    type: 'string' | 'boolean' | 'number' | 'fieldtype' | 'objecttypeid' | 'syncfieldid' | 'permission'
}

interface ISyncfieldsSuccess {
    l: ILanguage
    o: IObjectType
    i: IdName
    syncfields: ISyncField[]
}

interface ISyncfieldsError {
    l: ILanguage
    o: IObjectType
    i: IdName
    reason: string
}
